import AudioImageExample from "shared/assets/AudioImageExample.png";
import ExampleAudio2 from "shared/assets/ExampleAudio2.png";
import ExampleAudio3 from "shared/assets/ExampleAudio3.png";
import SpeakerExample from "shared/assets/Speaker_Example.png";
import SpeakerExample2 from "DreamCast/mockData/Speaker_List_Example_2.png";
import SpeakerExample3 from "DreamCast/mockData/Speaker_List_Example_3.png";
import SpeakerExample4 from "DreamCast/mockData/Speaker_List_Example_4.png";

// Set to false to disable all routed page mocks at once.
const PAGE_MOCKS_FLAG = process.env.REACT_APP_USE_DREAMCAST_PAGE_MOCKS;
export const USE_DREAMCAST_PAGE_MOCKS =
  String(PAGE_MOCKS_FLAG || "").toLowerCase() === "true";

const MEDIA_LIBRARY = [
  {
    // --- List fields (used by GET /api/dreamcast/media) ---
    id: "media-001",
    thumbnail: AudioImageExample,
    title: "Founders Executive Diamond Seminar",
    date: "2022-11-04T00:00:00.000Z",
    speaker: "Tsuruda and Kim & Lee",
    episodePart: "Episode 5 Part 2",
    sku: "WW11339v2.24",
    typeGroup: "wwg",
    category: "Audio",
    language: "english",
    workflowStatus: "published",
    displayStatus: "Available",
    isDraft: false,
    tags: ["classics", "diamond-seminar"],
    // --- Detail fields (used by GET /api/dreamcast/media/:id) ---
    detailState: {
      mediaType: "Audio",
      year: "2022",
      sku: "WW11339v2.24",
      title: "Founders Executive Diamond Seminar",
      creatorSpeaker: "Tsuruda and Kim & Lee",
      topic: "Executive Leadership",
      naCrNumber: "WW-11339",
      anzCrNumber: "",
      isThirdParty: false,
      isNew: false,
      markAsNewUntil: "",
    },
    thumbnailBuilderData: null,
    files: [
      {
        id: "WW11339v2.24",
        type: "Audio",
        version: "1",
        date: "2022-11-04T00:00:00.000Z",
        name: "WW11339v2.24.mp3",
        size: "28.4 MB",
        previewUrl: null,
      },
    ],
    archivedFiles: [],
    publishState: {
      status: "Scheduled",
      publishOn: "2038-01-15T15:30:00.000Z",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "9100",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["classics", "diamond-seminar"],
        hiddenTags: [],
      },
    },
    speakers: [
      { id: "spk-001", name: "Tsuruda", photo: SpeakerExample },
      { id: "spk-002", name: "Kim", photo: SpeakerExample },
      { id: "spk-003", name: "Lee", photo: SpeakerExample },
    ],
  },
  {
    id: "media-002",
    thumbnail: ExampleAudio2,
    title: "Diamond Seminar 2021",
    date: "2021-07-08T00:00:00.000Z",
    speaker: "Andrea Phillips",
    episodePart: "Episode 3 Part 1",
    sku: "WW10911v1.08",
    typeGroup: "wwg",
    category: "Audio",
    language: "english",
    workflowStatus: "in-review",
    displayStatus: "In Review",
    isDraft: false,
    tags: ["diamond-seminar", "classics"],
    detailState: {
      mediaType: "Audio",
      year: "2021",
      sku: "WW10911v1.08",
      title: "Diamond Seminar 2021",
      creatorSpeaker: "Andrea Phillips",
      topic: "Diamond Seminar",
      naCrNumber: "WW-10911",
      anzCrNumber: "",
      isThirdParty: false,
      isNew: false,
      markAsNewUntil: "",
    },
    thumbnailBuilderData: null,
    files: [
      {
        id: "WW10911v1.08",
        type: "Audio",
        version: "1",
        date: "2021-07-08T00:00:00.000Z",
        name: "WW10911v1.08.mp3",
        size: "31.2 MB",
        previewUrl: null,
      },
    ],
    archivedFiles: [],
    publishState: {
      status: "In Review",
      publishOn: "",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["diamond-seminar", "classics"],
        hiddenTags: [],
      },
    },
    speakers: [
      { id: "spk-004", name: "Andrea Phillips", photo: SpeakerExample },
    ],
  },
  {
    id: "media-003",
    thumbnail: ExampleAudio3,
    title: "Familia Enfoque",
    date: "2020-03-10T00:00:00.000Z",
    speaker: "Lee and Park",
    episodePart: "",
    sku: "3P2044v3.10",
    typeGroup: "3rd",
    category: "Music",
    language: "spanish",
    workflowStatus: "archived",
    displayStatus: "Archived",
    isDraft: false,
    tags: ["family-reunion", "specialty"],
    detailState: {
      mediaType: "Music",
      year: "2020",
      sku: "3P2044v3.10",
      title: "Familia Enfoque",
      creatorSpeaker: "Lee and Park",
      topic: "Family",
      naCrNumber: "",
      anzCrNumber: "",
      isThirdParty: true,
      isNew: false,
      markAsNewUntil: "",
    },
    thumbnailBuilderData: null,
    files: [
      {
        id: "3P2044v3.10",
        type: "Audio",
        version: "1",
        date: "2020-03-10T00:00:00.000Z",
        name: "3P2044v3.10.mp3",
        size: "18.7 MB",
        previewUrl: null,
      },
    ],
    archivedFiles: [],
    publishState: {
      status: "Archived",
      publishOn: "",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "",
      additionalIbos: "",
      tags: {
        selectedLocations: [],
        selectedLanguages: ["Spanish"],
        selectedOccupations: [],
        keywords: ["family-reunion", "specialty"],
        hiddenTags: [],
      },
    },
    speakers: [{ id: "spk-003", name: "Lee", photo: SpeakerExample }],
  },
  {
    id: "media-004",
    thumbnail: ExampleAudio2,
    title: "Business Basics",
    date: "2024-02-01T00:00:00.000Z",
    speaker: "Kevin Phillips",
    episodePart: "Episode 1",
    sku: "WW2001v1.01",
    typeGroup: "wwg",
    category: "Audio",
    language: "english",
    workflowStatus: "published",
    displayStatus: "Available",
    isDraft: false,
    tags: ["dreamnight", "classics"],
    detailState: {
      mediaType: "Audio",
      year: "2024",
      sku: "WW2001v1.01",
      title: "Business Basics",
      creatorSpeaker: "Kevin Phillips",
      topic: "Business",
      naCrNumber: "WW-2001",
      anzCrNumber: "",
      isThirdParty: false,
      isNew: false,
      markAsNewUntil: "",
    },
    thumbnailBuilderData: null,
    files: [
      {
        id: "WW2001v1.01",
        type: "Audio",
        version: "1",
        date: "2024-02-01T00:00:00.000Z",
        name: "WW2001v1.01.mp3",
        size: "24.1 MB",
        previewUrl: null,
      },
    ],
    archivedFiles: [],
    publishState: {
      status: "Scheduled",
      publishOn: "2040-06-01T12:00:00.000Z",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "9201",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["dreamnight", "classics"],
        hiddenTags: [],
      },
    },
    speakers: [
      { id: "spk-005", name: "Kevin Phillips", photo: SpeakerExample },
    ],
  },
  {
    id: "media-005",
    thumbnail: ExampleAudio3,
    title: "Wellness Focus",
    date: "2024-01-04T00:00:00.000Z",
    speaker: "Alex Harper",
    episodePart: "",
    sku: "WW2002v1.02",
    typeGroup: "wwg",
    category: "Video",
    language: "english",
    workflowStatus: "published",
    displayStatus: "Available",
    isDraft: false,
    tags: ["emerald-bio", "fma-other"],
    detailState: {
      mediaType: "Video",
      year: "2024",
      sku: "WW2002v1.02",
      title: "Wellness Focus",
      creatorSpeaker: "Alex Harper",
      topic: "Health & Wellness",
      naCrNumber: "WW-2002",
      anzCrNumber: "",
      isThirdParty: false,
      isNew: false,
      markAsNewUntil: "",
    },
    thumbnailBuilderData: null,
    files: [
      {
        id: "WW2002v1.02",
        type: "Video",
        version: "1",
        date: "2024-01-04T00:00:00.000Z",
        name: "WW2002v1.02.mp4",
        size: "512.3 MB",
        previewUrl: null,
      },
    ],
    archivedFiles: [],
    publishState: {
      status: "Scheduled",
      publishOn: "2037-11-20T09:45:00.000Z",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 24,
      groups: "1,6,7",
      familyReunions: "",
      diamonds: "",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["emerald-bio", "fma-other"],
        hiddenTags: [],
      },
    },
    speakers: [{ id: "spk-006", name: "Alex Harper", photo: SpeakerExample }],
  },
  {
    id: "media-006",
    thumbnail: ExampleAudio2,
    title: "Relationship Framework",
    date: "2023-12-05T00:00:00.000Z",
    speaker: "J. Carter",
    episodePart: "Episode 2",
    sku: "WW2003v1.03",
    typeGroup: "3rd",
    category: "Audio",
    language: "korean",
    workflowStatus: "upcoming",
    displayStatus: "In Review",
    isDraft: true,
    tags: ["fma-tsika", "specialty"],
    detailState: {
      mediaType: "Audio",
      year: "2023",
      sku: "WW2003v1.03",
      title: "Relationship Framework",
      creatorSpeaker: "J. Carter",
      topic: "Relationships",
      naCrNumber: "",
      anzCrNumber: "",
      isThirdParty: true,
      isNew: true,
      markAsNewUntil: "2024-03-01T23:59:00.000Z",
    },
    thumbnailBuilderData: null,
    files: [
      {
        id: "WW2003v1.03",
        type: "Audio",
        version: "1",
        date: "2023-12-05T00:00:00.000Z",
        name: "WW2003v1.03.mp3",
        size: "22.8 MB",
        previewUrl: null,
      },
    ],
    archivedFiles: [],
    publishState: {
      status: "In Review",
      publishOn: "2024-01-10T09:00:00.000Z",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "2024-01-15T09:00:00.000Z",
    },
    contentSettings: {
      pinLevelPermissions: 28,
      groups: "1,5,6,7",
      familyReunions: "",
      diamonds: "",
      additionalIbos: "",
      tags: {
        selectedLocations: [],
        selectedLanguages: ["Korean"],
        selectedOccupations: [],
        keywords: ["fma-tsika", "specialty"],
        hiddenTags: [],
      },
    },
    speakers: [],
  },
];

const CONTENT_SETTINGS_CONFIG = {
  attributeTypes: [
    {
      AttributeTypeCode: "MEDIA_SOURCE",
      AttributeType: "Source",
      ComponentTypeCode: "PRIMARY_CHECKBOX",
      Attributes: [
        {
          Attribute: "WWG Exclusive",
          AttributeCode: "MEDIA_SOURCE_WWG_EXCLUSIVE",
        },
        {
          Attribute: "3rd Party",
          AttributeCode: "MEDIA_SOURCE_3RD_PARTY",
        },
      ],
    },
  ],
  // Hardcoded — matches shape from other app (dropdownReunionOptions)
  familyReunionGroups: [
    { id: 15, name: "Duncan Family Reunion" },
    { id: 16, name: "Baker Family Reunion" },
    { id: 17, name: "Whalen Family Reunion" },
    { id: 8192, name: "Puryear Family Reunion" },
    { id: 1048576, name: "Rice Family Reunion" },
    { id: 2097152, name: "Erickson Family Reunion" },
  ],
  // From GET /v1/news/diamonds → [{ IBO, name }]
  diamonds: [
    { IBO: "15", name: "TSIKA P" },
    { IBO: "1754", name: "ERICKSON R" },
    { IBO: "2559", name: "DUNCAN G" },
    { IBO: "5082", name: "FELBER D" },
    { IBO: "7298", name: "PARDEE M" },
    { IBO: "7789", name: "HAWKINS B" },
    { IBO: "8252", name: "PURYEAR J" },
    { IBO: "9100", name: "TSURUDA M" },
    { IBO: "9201", name: "PHILLIPS K" },
    { IBO: "9350", name: "HARIMOTO S" },
    { IBO: "9401", name: "RICE L" },
    { IBO: "9450", name: "BAKER G" },
    { IBO: "9500", name: "WHALEN D" },
    { IBO: "9550", name: "LEE J" },
    { IBO: "9600", name: "DUNCAN B" },
    { IBO: "9650", name: "YUEN D" },
    { IBO: "9700", name: "ROSARIO J" },
    { IBO: "9750", name: "JOHNSON B" },
    { IBO: "9800", name: "JONES T" },
    { IBO: "9850", name: "KIM N" },
  ],
  // From GET /v1/news/groups → [{ groupId, name, ... }]
  groups: [
    { groupId: 1, name: "Active Premier Members" },
    { groupId: 2, name: "Active Basic Members" },
    { groupId: 3, name: "Complimentary Members" },
    { groupId: 4, name: "Active Associate IBOs" },
    { groupId: 5, name: "Active Platinums" },
    { groupId: 6, name: "Active Emeralds" },
    { groupId: 7, name: "Active Diamonds" },
  ],
  locationOptions: ["US", "Canada", "Jamaica", "Japan"],
  languageOptions: ["English", "Spanish", "Korean", "French", "Chinese"],
  occupationOptions: ["Entrepreneur", "Teacher", "Engineer"],
  keywordOptions: [
    "Classics",
    "Diamond Bio",
    "Diamond Seminar",
    "DreamNight",
    "Emerald Bio",
    "Family Reunion",
    "FMA - Maxwell",
    "FMA - Other",
    "FMA - Tsika",
    "Leadership",
    "Retail",
    "Specialty",
  ],
  hiddenTagOptions: ["Internal", "Archived", "Promo"],
};

const SPEAKER_DIRECTORY = [
  {
    // --- List fields (used by GET /api/dreamcast/speakers) ---
    id: "speaker-001",
    photo: SpeakerExample2,
    name: "Trevor & Lexi Baker",
    type: "diamond",
    language: "english",
    imageType: "individual",
    isDraft: false,
    isThirdParty: false,
    isDiamond: true,
    // --- Detail fields (used by GET /api/dreamcast/speakers/:id) ---
    details: {
      startedBusiness: "2008",
      wentDiamond: "2014",
      hometownA: "Portland, OR",
      hometownB: "Portland, OR",
      previousOccupationA: "Marketing Manager",
      previousOccupationB: "Sales Consultant",
      funFact: "Met at a networking event and started their business together.",
    },
    intros: [
      {
        id: "intro-001",
        type: "Audio Intro",
        version: "v2",
        date: "8/15/2026",
      },
    ],
    archivedIntros: [],
    audios: [
      {
        id: "media-001",
        thumbnail: AudioImageExample,
        title: "Free Enterprise 2022",
        date: "11/4/2022",
        speaker: "Tsuruda and Kim & Lee",
        episodePart: "Episode 5 Part 2",
      },
    ],
  },
  {
    id: "speaker-002",
    photo: SpeakerExample,
    name: "Andrea Phillips",
    type: "diamond",
    language: "english",
    imageType: "individual",
    isDraft: false,
    isThirdParty: false,
    isDiamond: true,
    details: {
      startedBusiness: "2012",
      wentDiamond: "2018",
      hometownA: "Austin, TX",
      hometownB: "",
      previousOccupationA: "Financial Advisor",
      previousOccupationB: "",
      funFact: "Passionate about mentoring new entrepreneurs.",
    },
    intros: [
      {
        id: "intro-002",
        type: "Audio Intro",
        version: "v1",
        date: "7/20/2026",
      },
    ],
    archivedIntros: [],
    audios: [
      {
        id: "media-002",
        thumbnail: AudioImageExample,
        title: "Diamond Seminar 2021",
        date: "7/8/2021",
        speaker: "Andrea Phillips",
        episodePart: "Episode 3 Part 1",
      },
    ],
  },
  {
    id: "speaker-003",
    photo: SpeakerExample3,
    name: "Kevin Phillips",
    type: "diamond",
    language: "english",
    imageType: "individual",
    isDraft: false,
    isThirdParty: false,
    isDiamond: true,
    details: {
      startedBusiness: "2015",
      wentDiamond: "2021",
      hometownA: "Denver, CO",
      hometownB: "",
      previousOccupationA: "Business Consultant",
      previousOccupationB: "",
      funFact: "Loves hiking in the Rocky Mountains.",
    },
    intros: [],
    archivedIntros: [],
    audios: [],
  },
  {
    id: "speaker-004",
    photo: SpeakerExample4,
    name: "Rosario",
    type: "3rd",
    language: "spanish",
    imageType: "individual",
    isDraft: false,
    isThirdParty: true,
    isDiamond: false,
    details: {
      startedBusiness: "2010",
      wentDiamond: "",
      hometownA: "Mexico City, MX",
      hometownB: "",
      previousOccupationA: "Teacher",
      previousOccupationB: "",
      funFact: "Dedicated to growing the business in Latin America.",
    },
    intros: [],
    archivedIntros: [],
    audios: [],
  },
  {
    id: "speaker-005",
    photo: SpeakerExample2,
    name: "Yamamoto",
    type: "diamond",
    language: "korean",
    imageType: "individual",
    isDraft: false,
    isThirdParty: false,
    isDiamond: true,
    details: {
      startedBusiness: "2009",
      wentDiamond: "2017",
      hometownA: "Seoul, Korea",
      hometownB: "",
      previousOccupationA: "Engineer",
      previousOccupationB: "",
      funFact: "First Diamond in their region.",
    },
    intros: [],
    archivedIntros: [],
    audios: [],
  },
];

const PLAYLISTS = [
  {
    // --- List fields (used by GET /api/dreamcast/playlists) ---
    id: "playlist-001",
    title: "WWG Business Essentials",
    playlistType: "WWG Playlist",
    type: "Business",
    typeGroup: "wwg",
    language: "english",
    date: "2022-11-04T00:00:00.000Z",
    workflowStatus: "published",
    displayStatus: "Available",
    isDraft: false,
    tags: ["classics", "diamond-seminar"],
    // --- Detail fields (used by GET /api/dreamcast/playlists/:id) ---
    thumbnailState: { mode: "audios", customImageUrl: null },
    audios: [
      {
        id: "media-001",
        thumbnail: AudioImageExample,
        title: "Founders Executive Diamond Seminar",
        sku: "WW11339v2.24",
        speaker: "Tsuruda and Kim & Lee",
        category: "Audio",
        language: "english",
        order: 2,
      },
      {
        id: "media-002",
        thumbnail: ExampleAudio2,
        title: "Diamond Seminar 2021",
        sku: "WW10911v1.08",
        speaker: "Andrea Phillips",
        category: "Audio",
        language: "english",
        order: 1,
      },
      {
        id: "media-003",
        thumbnail: ExampleAudio3,
        title: "Familia Enfoque",
        sku: "3P2044v3.10",
        speaker: "Lee and Park",
        category: "Music",
        language: "spanish",
        order: 3,
      },
      {
        id: "media-004",
        thumbnail: ExampleAudio2,
        title: "Business Basics",
        sku: "WW2001v1.01",
        speaker: "Kevin Phillips",
        category: "Audio",
        language: "english",
        order: 4,
      },
    ],
    publishState: {
      status: "Published",
      publishOn: "",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "9100,9201",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["classics", "diamond-seminar"],
        hiddenTags: [],
      },
    },
  },
  {
    id: "playlist-002",
    title: "Family Reunion Highlights",
    playlistType: "WWG Playlist",
    type: "Relationships",
    typeGroup: "wwg",
    language: "english",
    date: "2023-05-14T00:00:00.000Z",
    workflowStatus: "published",
    displayStatus: "Available",
    isDraft: false,
    tags: ["family-reunion", "classics"],
    thumbnailState: { mode: "audios", customImageUrl: null },
    audios: [
      {
        id: "media-001",
        thumbnail: AudioImageExample,
        title: "Founders Executive Diamond Seminar",
        sku: "WW11339v2.24",
        speaker: "Tsuruda and Kim & Lee",
        category: "Audio",
        language: "english",
        order: 1,
      },
      {
        id: "media-003",
        thumbnail: ExampleAudio3,
        title: "Familia Enfoque",
        sku: "3P2044v3.10",
        speaker: "Lee and Park",
        category: "Music",
        language: "spanish",
        order: 2,
      },
      {
        id: "media-005",
        thumbnail: ExampleAudio3,
        title: "Wellness Focus",
        sku: "WW2002v1.02",
        speaker: "Alex Harper",
        category: "Video",
        language: "english",
        order: 3,
      },
    ],
    publishState: {
      status: "Published",
      publishOn: "",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "15",
      diamonds: "9100",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English", "Spanish"],
        selectedOccupations: [],
        keywords: ["family-reunion", "classics"],
        hiddenTags: [],
      },
    },
  },
  {
    id: "playlist-003",
    title: "Korean Leadership Set",
    playlistType: "WWG Playlist",
    type: "Business",
    typeGroup: "3rd",
    language: "korean",
    date: "2024-02-21T00:00:00.000Z",
    workflowStatus: "published",
    displayStatus: "Available",
    isDraft: false,
    tags: ["specialty", "fma-tsika"],
    thumbnailState: { mode: "audios", customImageUrl: null },
    audios: [
      {
        id: "media-006",
        thumbnail: ExampleAudio2,
        title: "Relationship Framework",
        sku: "WW2003v1.03",
        speaker: "J. Carter",
        category: "Audio",
        language: "korean",
        order: 1,
      },
      {
        id: "media-002",
        thumbnail: ExampleAudio2,
        title: "Diamond Seminar 2021",
        sku: "WW10911v1.08",
        speaker: "Andrea Phillips",
        category: "Audio",
        language: "english",
        order: 2,
      },
      {
        id: "media-004",
        thumbnail: ExampleAudio2,
        title: "Business Basics",
        sku: "WW2001v1.01",
        speaker: "Kevin Phillips",
        category: "Audio",
        language: "english",
        order: 3,
      },
    ],
    publishState: {
      status: "Published",
      publishOn: "",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "",
      additionalIbos: "",
      tags: {
        selectedLocations: [],
        selectedLanguages: ["Korean"],
        selectedOccupations: [],
        keywords: ["specialty", "fma-tsika"],
        hiddenTags: [],
      },
    },
  },
];

const DIGITAL_DELIVERY_CURRENT = [
  {
    id: "delivery-current-001",
    thumbnail: ExampleAudio2,
    title: "Free Enterprise 2022",
    date: "2022-11-04T00:00:00.000Z",
    speaker: "Tsuruda and Kim & Lee",
    episode: "Episode 2 Part 1",
    sku: "WW1339v2.24",
    type: "Audio",
    category: "Audio",
    language: "english",
    status: "published",
    isDraft: false,
    tags: ["Free Enterprise", "Lifestyle"],
    // --- Detail fields (used by GET /api/dreamcast/digital-delivery/:id) ---
    thumbnailBuilderData: null,
    detailState: {
      mediaType: "Audio",
      year: "2022",
      sku: "WW1339v2.24",
      title: "Free Enterprise 2022",
      creatorSpeaker: "Tsuruda and Kim & Lee",
      topic: "Free Enterprise",
      naCrNumber: "WW-1339",
      anzCrNumber: "",
      isThirdParty: false,
      isNew: false,
      markAsNewUntil: "",
    },
    publishState: {
      status: "Published",
      publishOn: "2022-11-01T08:00:00.000Z",
      unpublishOn: "2025-11-04T23:59:00.000Z",
      unpublishEnabled: true,
      digitalDeliveryEnabled: true,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "9100",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["Free Enterprise", "Lifestyle"],
        hiddenTags: [],
      },
    },
  },
  {
    id: "delivery-current-002",
    thumbnail: ExampleAudio3,
    title: "Leadership Summit",
    date: "2024-02-06T00:00:00.000Z",
    speaker: "Kevin & Andrea Phillips",
    episode: "",
    sku: "EB1200v10.04",
    type: "Video",
    category: "Video",
    language: "english",
    status: "published",
    isDraft: false,
    tags: ["Specialty", "Classics"],
    // --- Detail fields (used by GET /api/dreamcast/digital-delivery/:id) ---
    thumbnailBuilderData: null,
    detailState: {
      mediaType: "Video",
      year: "2024",
      sku: "EB1200v10.04",
      title: "Leadership Summit",
      creatorSpeaker: "Kevin & Andrea Phillips",
      topic: "Leadership",
      naCrNumber: "EB-1200",
      anzCrNumber: "",
      isThirdParty: false,
      isNew: false,
      markAsNewUntil: "",
    },
    publishState: {
      status: "Published",
      publishOn: "",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: true,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["Specialty", "Classics"],
        hiddenTags: [],
      },
    },
  },
];

const DIGITAL_DELIVERY_UPCOMING = [
  {
    id: "delivery-upcoming-001",
    thumbnail: ExampleAudio2,
    title: "Spring Leadership 2022",
    date: "2022-11-04T00:00:00.000Z",
    speaker: "Harimoto & Tsuruda",
    episode: "",
    sku: "WWZ1327v11.23",
    type: "Audio",
    category: "Audio",
    language: "english",
    status: "upcoming",
    isDraft: true,
    tags: ["Event", "Lifestyle"],
    // --- Detail fields (used by GET /api/dreamcast/digital-delivery/:id) ---
    thumbnailBuilderData: null,
    detailState: {
      mediaType: "Audio",
      year: "2022",
      sku: "WWZ1327v11.23",
      title: "Spring Leadership 2022",
      creatorSpeaker: "Harimoto & Tsuruda",
      topic: "Leadership",
      naCrNumber: "WWZ-1327",
      anzCrNumber: "",
      isThirdParty: false,
      isNew: false,
      markAsNewUntil: "",
    },
    publishState: {
      status: "Upcoming",
      publishOn: "2026-09-15T10:00:00.000Z",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: true,
      showAsUpcomingOn: "2026-08-20T06:00:00.000Z",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["Event", "Lifestyle"],
        hiddenTags: [],
      },
    },
  },
  {
    id: "delivery-upcoming-002",
    thumbnail: ExampleAudio3,
    title: "Emerald Bio",
    date: "2022-11-04T00:00:00.000Z",
    speaker: "Kevin & Andrea Phillips",
    episode: "",
    sku: "EB1456v12.25",
    type: "Video",
    category: "Video",
    language: "english",
    status: "upcoming",
    isDraft: false,
    tags: ["Emerald", "Event"],
    // --- Detail fields (used by GET /api/dreamcast/digital-delivery/:id) ---
    thumbnailBuilderData: null,
    detailState: {
      mediaType: "Video",
      year: "2022",
      sku: "EB1456v12.25",
      title: "Emerald Bio",
      creatorSpeaker: "Kevin & Andrea Phillips",
      topic: "Emerald",
      naCrNumber: "EB-1456",
      anzCrNumber: "",
      isThirdParty: false,
      isNew: false,
      markAsNewUntil: "",
    },
    publishState: {
      status: "Upcoming",
      publishOn: "",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: true,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["Emerald", "Event"],
        hiddenTags: [],
      },
    },
  },
];

const DIGITAL_DELIVERY_HISTORY = [
  {
    id: "delivery-history-001",
    thumbnail: ExampleAudio2,
    title: "Free Enterprise 2021",
    date: "2021-06-12T00:00:00.000Z",
    speaker: "Tsuruda and Kim & Lee",
    episode: "",
    sku: "WW1250v3.11",
    type: "Audio",
    category: "Audio",
    language: "english",
    status: "archived",
    isDraft: false,
    tags: ["Free Enterprise", "Classic"],
    // --- Detail fields (used by GET /api/dreamcast/digital-delivery/:id) ---
    thumbnailBuilderData: null,
    detailState: {
      mediaType: "Audio",
      year: "2021",
      sku: "WW1250v3.11",
      title: "Free Enterprise 2021",
      creatorSpeaker: "Tsuruda and Kim & Lee",
      topic: "Free Enterprise",
      naCrNumber: "WW-1250",
      anzCrNumber: "",
      isThirdParty: false,
      isNew: false,
      markAsNewUntil: "",
    },
    publishState: {
      status: "Archived",
      publishOn: "",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["Free Enterprise", "Classic"],
        hiddenTags: [],
      },
    },
  },
  {
    id: "delivery-history-002",
    thumbnail: ExampleAudio3,
    title: "Leadership Summit 2021",
    date: "2021-03-05T00:00:00.000Z",
    speaker: "Kevin & Andrea Phillips",
    episode: "",
    sku: "EB1200v09.01",
    type: "Video",
    category: "Video",
    language: "english",
    status: "published",
    isDraft: false,
    tags: ["Leadership", "Archive"],
    // --- Detail fields (used by GET /api/dreamcast/digital-delivery/:id) ---
    thumbnailBuilderData: null,
    detailState: {
      mediaType: "Video",
      year: "2021",
      sku: "EB1200v09.01",
      title: "Leadership Summit 2021",
      creatorSpeaker: "Kevin & Andrea Phillips",
      topic: "Leadership",
      naCrNumber: "EB-1200",
      anzCrNumber: "",
      isThirdParty: false,
      isNew: false,
      markAsNewUntil: "",
    },
    publishState: {
      status: "Published",
      publishOn: "",
      unpublishOn: "",
      unpublishEnabled: false,
      digitalDeliveryEnabled: false,
      showAsUpcomingOn: "",
    },
    contentSettings: {
      pinLevelPermissions: 30,
      groups: "1,3,4,5,6,7",
      familyReunions: "",
      diamonds: "",
      additionalIbos: "",
      tags: {
        selectedLocations: ["US"],
        selectedLanguages: ["English"],
        selectedOccupations: [],
        keywords: ["Leadership", "Archive"],
        hiddenTags: [],
      },
    },
  },
];

const RADIO_AUDIO_LIBRARY = [
  {
    id: "media-001",
    thumbnail: AudioImageExample,
    title: "Free Enterprise 2022",
    date: "2022-11-04T00:00:00.000Z",
    speaker: "Tsuruda and Kim & Lee",
    episodePart: "Episode 5 Part 2",
    sku: "WW11339v2.24",
    type: "Audio",
    typeGroup: "wwg",
    language: "english",
    workflowStatus: "published",
    displayStatus: "Available",
    tags: ["classics", "leadership"],
  },
  {
    id: "media-002",
    thumbnail: ExampleAudio2,
    title: "Diamond Seminar 2021",
    date: "2021-07-08T00:00:00.000Z",
    speaker: "Andrea Phillips",
    episodePart: "Episode 3 Part 1",
    sku: "WW10911v1.08",
    type: "Audio",
    typeGroup: "wwg",
    language: "english",
    workflowStatus: "in-review",
    displayStatus: "In Review",
    tags: ["diamond-seminar", "specialty"],
  },
  {
    id: "media-003",
    thumbnail: AudioImageExample,
    title: "Familia Enfoque",
    date: "2020-03-10T00:00:00.000Z",
    speaker: "Lee & Park",
    episodePart: "",
    sku: "3P2044v3.10",
    type: "Music",
    typeGroup: "3rd",
    language: "spanish",
    workflowStatus: "archived",
    displayStatus: "Archived",
    tags: ["family-reunion"],
  },
  {
    id: "media-004",
    thumbnail: ExampleAudio2,
    title: "Wellness Focus Intro",
    date: "2024-01-06T00:00:00.000Z",
    speaker: "WWG Radio",
    episodePart: "",
    sku: "WW2002v1.02",
    type: "Video",
    typeGroup: "wwg",
    language: "english",
    workflowStatus: "published",
    displayStatus: "Available",
    tags: ["classics"],
  },
];

const RADIO_PROGRAMS = [
  {
    id: "radio-001",
    thumbnails: [
      AudioImageExample,
      ExampleAudio2,
      AudioImageExample,
      ExampleAudio2,
      AudioImageExample,
      ExampleAudio2,
    ],
    overflowCount: 0,
    title: "Functions 2022",
    createdDate: "11/4/2022",
    createdAt: "2022-11-04T09:30:00.000Z",
    creator: "WWG Radio",
    preset: "Business",
    presetKey: "business",
    workflowStatus: "published",
    statusLabel: "Published",
    isDraft: false,
    // Airs Mon + Wed — conflicts with radio-003 on Wednesday
    schedule: {
      mon: true,
      tue: false,
      wed: true,
      thu: false,
      fri: false,
      sat: false,
      sun: false,
    },
    audios: [RADIO_AUDIO_LIBRARY[0], RADIO_AUDIO_LIBRARY[1]],
  },
  {
    id: "radio-002",
    thumbnails: [ExampleAudio2],
    overflowCount: 0,
    title: "Leadership Live",
    createdDate: "11/2/2022",
    createdAt: "2022-11-02T11:45:00.000Z",
    creator: "DreamCast Team",
    preset: "Relationships",
    presetKey: "relationships",
    workflowStatus: "published",
    statusLabel: "Published",
    isDraft: false,
    schedule: {
      mon: false,
      tue: true,
      wed: false,
      thu: true,
      fri: false,
      sat: false,
      sun: false,
    },
    audios: [RADIO_AUDIO_LIBRARY[1]],
  },
  {
    id: "radio-003",
    thumbnails: [AudioImageExample, ExampleAudio2, AudioImageExample],
    overflowCount: 0,
    title: "Mid-Week Business",
    createdDate: "10/22/2022",
    createdAt: "2022-10-22T08:15:00.000Z",
    creator: "WWG Radio",
    preset: "Business",
    presetKey: "business",
    workflowStatus: "published",
    statusLabel: "Published",
    isDraft: false,
    // Airs Wed + Fri — conflicts with radio-001 on Wednesday
    schedule: {
      mon: false,
      tue: false,
      wed: true,
      thu: false,
      fri: true,
      sat: false,
      sun: false,
    },
    audios: [RADIO_AUDIO_LIBRARY[0], RADIO_AUDIO_LIBRARY[3]],
  },
  {
    id: "radio-004",
    thumbnails: [AudioImageExample],
    overflowCount: 0,
    title: "Wellness Focus",
    createdDate: "10/10/2022",
    createdAt: "2022-10-10T13:40:00.000Z",
    creator: "WWG Radio",
    preset: "Health",
    presetKey: "health",
    workflowStatus: "in-review",
    statusLabel: "In Review",
    isDraft: false,
    schedule: {
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: true,
      sun: false,
    },
    audios: [RADIO_AUDIO_LIBRARY[3]],
  },
  {
    id: "radio-005",
    thumbnails: [
      ExampleAudio2,
      AudioImageExample,
      ExampleAudio2,
      AudioImageExample,
      ExampleAudio2,
    ],
    overflowCount: 0,
    title: "Dream Weekend",
    createdDate: "9/12/2022",
    createdAt: "2022-09-12T07:20:00.000Z",
    creator: "DreamCast Team",
    preset: "Lifestyle",
    presetKey: "lifestyle",
    workflowStatus: "in-review",
    statusLabel: "Draft",
    isDraft: true,
    schedule: {
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      sun: true,
    },
    audios: [RADIO_AUDIO_LIBRARY[1], RADIO_AUDIO_LIBRARY[2]],
  },
];

export const DREAMCAST_PAGE_MOCKS = {
  audios: {
    initialAudios: MEDIA_LIBRARY,
    speakerDirectory: SPEAKER_DIRECTORY,
    initialContentSettingsConfig: CONTENT_SETTINGS_CONFIG,
    disableInitialFetch: true,
  },
  media: {
    initialAudios: MEDIA_LIBRARY,
    speakerDirectory: SPEAKER_DIRECTORY,
    initialContentSettingsConfig: CONTENT_SETTINGS_CONFIG,
    disableInitialFetch: true,
  },
  playlists: {
    initialPlaylists: PLAYLISTS,
    audioLibrary: MEDIA_LIBRARY,
    initialContentSettingsConfig: CONTENT_SETTINGS_CONFIG,
    disableInitialFetch: true,
  },
  digitalDelivery: {
    currentItems: DIGITAL_DELIVERY_CURRENT,
    upcomingItems: DIGITAL_DELIVERY_UPCOMING,
    historyItems: DIGITAL_DELIVERY_HISTORY,
    disableInitialFetch: true,
  },
  radio: {
    initialPrograms: RADIO_PROGRAMS,
    audioLibrary: RADIO_AUDIO_LIBRARY,
    disableInitialFetch: true,
  },
  speakers: {
    initialSpeakers: SPEAKER_DIRECTORY,
    disableInitialFetch: true,
  },
};
